import { render, staticRenderFns } from "./AiBookThirdShelvesManage.vue?vue&type=template&id=73a6a786&scoped=true"
import script from "./AiBookThirdShelvesManage.vue?vue&type=script&lang=js"
export * from "./AiBookThirdShelvesManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a6a786",
  null
  
)

export default component.exports